import { render, staticRenderFns } from "./DiagnosticDetailsModal.vue?vue&type=template&id=72a479dc&scoped=true&"
import script from "./DiagnosticDetailsModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosticDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticDetailsModal.vue?vue&type=style&index=0&id=72a479dc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a479dc",
  null
  
)

export default component.exports